export default __webpack_public_path__ + "static/media/cooperation-img-2.56b4a55f.png";